import React from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import * as yup from 'yup';

import { useFormatMessage } from 'hooks';
import UserForm from 'components/UserForm';
import { modifyUser } from 'state/actions/users';
import ChangePassword from 'components/ChangePassword';
import UserDevices from 'components/UserDevices';

const schema = yup.object().shape({
  username: yup.string().required(),
  role: yup.string().required(),
  created: yup.string().required(),
  devices_limit: yup.number().transform( cv => Number.isNaN(cv) ? undefined : cv).positive().integer()
});

const Profile = () => {
  const { userData } = useSelector(
    (state) => ({
      userData: state.auth.userData,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  const onSubmitHandler = (value) => {
    const userCompanies = value?.companies?.map(userCompany => userCompany.value) || [];

    const newUser = {
      ...value,
      companies: userCompanies,
      isEditing: true,
      isProfile: true,
      id: userData.id,
    };

    dispatch(modifyUser(newUser));
  };

  return (
    <>
      <section className="hero is-hero-bar">
        <div className="hero-body">
          <h1 className="title">{useFormatMessage('Profile.profile')}</h1>
        </div>
      </section>
      <section className="section is-main-section">
        <UserForm
          isEditing
          isProfile
          user={userData}
          onSubmitHandler={onSubmitHandler}
          schema={schema}
        />
        <UserDevices userId={userData.id} />
        <ChangePassword />
      </section>
    </>
  );
};

export default Profile;
